export default __webpack_public_path__ + "static/media/frankhomies-logo-white.59aa9c7a.png";